import { render, staticRenderFns } from "./BalanceReserveView.vue?vue&type=template&id=97a6b082&scoped=true&"
import script from "./BalanceReserveView.vue?vue&type=script&lang=js&"
export * from "./BalanceReserveView.vue?vue&type=script&lang=js&"
import style0 from "./BalanceReserveView.vue?vue&type=style&index=0&id=97a6b082&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a6b082",
  null
  
)

export default component.exports